import { module } from 'angular';
import { ngModule as foundationThemingModule } from 'cg-foundation-theming';
import { CopyLinkButtonDirective } from './directives/copy-link-button';
import { PdfGeneratorDirective } from './directives/pdf-generator';
import { SharePageDirective } from './directives/share-page';
import '../scss/_master.scss';
export var ngModule = module('gn.audio.cg.sharing', [foundationThemingModule.name])
    .directive('copyLinkButton', CopyLinkButtonDirective)
    .directive('pdfGenerator', PdfGeneratorDirective)
    .directive('sharePage', SharePageDirective);
